import {
  IsNotEmpty,
  IsUUID,
  IsNumber,
  IsOptional,
  IsIn,
  IsInt,
  IsBoolean,
} from 'class-validator';

export class PostCashTransactionGroupTransactionDto {
  @IsNotEmpty()
  @IsUUID(4)
  cashTransactionGroupId!: string;

  @IsOptional()
  @IsNotEmpty()
  @IsNumber({}, { each: true })
  coins?: number[];

  @IsOptional()
  @IsNumber()
  bankAccountAmount?: number;

  @IsOptional()
  @IsInt()
  immediateFeeAmount?: number;
  @IsOptional()
  @IsBoolean()
  immediateFeeTracked?: boolean;
  @IsOptional()
  @IsInt()
  separateFeeAmount?: number;
  @IsOptional()
  @IsNumber()
  separateFeePercentage?: number;

  @IsOptional()
  notes?: string;

  @IsNotEmpty()
  @IsIn(['withdrawal', 'deposit'])
  type!: 'withdrawal' | 'deposit';
}
